import * as React from "react";
import MediaQuery from "react-responsive";

import { appendToClassName } from "lib/helpers";

export function Desktop(props: { children?: React.ReactNode }) {
  return <MediaQuery minWidth={921}>{props.children}</MediaQuery>;
}

export function Tablet(props: { children?: React.ReactNode }) {
  return (
    <MediaQuery maxWidth={920} minWidth={768}>
      {props.children}
    </MediaQuery>
  );
}

export function Mobile(props: { children?: React.ReactNode }) {
  return <MediaQuery maxWidth={767}>{props.children}</MediaQuery>;
}

interface Props {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  externalRef?: React.RefObject<HTMLDivElement>;
}

interface State {
  count: number;
}

export class Div3 extends React.Component<Props, State> {
  timer: ReturnType<typeof setInterval> | null;
  public constructor(props: Props) {
    super(props);
    this.state = {
      count: 0,
    };
    this.timer = null;
  }
  public componentDidMount() {
    this.startTimer();
  }
  public componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  private startTimer = () => {
    this.timer = setInterval(() => this.increaseCount(), 1000);
  };

  private increaseCount() {
    this.setState(prevState => ({ count: prevState.count + 1 }));
  }

  public render() {
    const { children, className, id, externalRef } = this.props;

    const width = window.innerWidth;
    const isDesktop = width >= 921;
    const isTablet = width >= 768 && width <= 920;
    const isMobile = width <= 767;

    return (
      <>
        {isDesktop && (
          <Desktop>
            <div
              id={id || ""}
              className={appendToClassName("desktop", className)}
              ref={externalRef}
            >
              {children}
            </div>
          </Desktop>
        )}
        {isTablet && (
          <Tablet>
            <div
              id={id || ""}
              className={appendToClassName("tablet", className)}
              ref={externalRef}
            >
              {children}
            </div>
          </Tablet>
        )}
        {isMobile && (
          <Mobile>
            <div
              id={id || ""}
              className={appendToClassName("mobile", className)}
              ref={externalRef}
            >
              {children}
            </div>
          </Mobile>
        )}
      </>
    );
  }
}
